const CryptoJS = require('crypto-js');

//十六位十六进制数作为密钥
// const key = CryptoJS.enc.Utf8.parse("7845987458lkjhst");
const key = CryptoJS.enc.Utf8.parse("sadjsdYaaUksdasa");
//解密方法
function Decrypt(word) {
  if(word == '') return '';
  let decrypt = CryptoJS.AES.decrypt(word, key, { mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
  // return   CryptoJS.enc.Utf8.stringify(decrypt).toString();
}

//加密方法
function Encrypt(word) {
  if(word == '') return '';
  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
  return encrypted.toString();
}




export {
  Decrypt,
  Encrypt,
}


// WEBPACK FOOTER //
// ./src/script/tools/aes.js